import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductService } from '@app/api/api';
import { Subscription, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';

@Component({
  selector: 'meu-app-home-page-hot-deal',
  templateUrl: './app-home-page-hot-deal.component.html',
  styleUrls: ['./app-home-page-hot-deal.component.scss']
})
export class AppHomePageHotDealComponent implements OnInit, OnDestroy {
  hotDealProduct: any = [];
  hotDealProduct$ = new Subject
  private subscriptions: Subscription[] = [];
  host = environment.backendhost;
  constructor(
    private productService: ProductService
  ) { }

  showLoadMore = true;
  pageSize: number = 10;
  pageIndex: number = 1;

  ngOnInit() {
    this.getHotDeal();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
  getHotDeal() {
    this.subscriptions.push(
      this.productService.apiProductsHotdealsGet('is_hidden==false', '', this.pageIndex, this.pageSize).subscribe(res => {
        this.hotDealProduct = res.data.collection;
        this.hotDealProduct.forEach(item => {
          item.sale_off = Math.round(100 - (item.price / item.origin_price) * 100);
          item.seo_name = UtilService.slugify(item.name);//item.name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
        })
        this.hotDealProduct$.next(res.data.collection);
        if (this.pageSize >= res.data.total) {
          this.showLoadMore = false;
        }
      }));
  }

  loadMore() {
    this.pageSize += 10;
    this.getHotDeal();
  }
}
